import { useMutation } from "@tanstack/react-query";
import { useAPIClient } from "render/context/APIContext";
import { useReporting } from "render/hooks/useReporting";

export function useClearRoomControllerMutation() {
  const apiClient = useAPIClient();
  const { logError } = useReporting();

  return useMutation({
    mutationFn({ patientId, visitId }: { patientId: string; visitId: string }) {
      return apiClient.visit.clearRoomController({ patientId, visitId }).result;
    },
    onError: (error) => logError(`Failed to clear room controller: ${error}`),
  });
}
